const purchase = {
  title: "HitPaw Online Pro",
  subTitle: "Elija el plan adecuado con precios sencillos y transparentes",
  monthlyUppercase: "MENSUALMENTE",
  montly: "Mensualmente",
  free: "GRATIS",
  yearlyUppercase: "AÑO",
  yearly: "Anual",
  inService: "En servicio",
  buyBtn: "Comprar ahora",
  freeTips1: "Soporta un tamaño máximo de archivo de 20MB",
  freeTips2: "6 archivos por día",
  freeTips3: "Velocidad de procesamiento normal",
  freeTips4: "Velocidad de descarga normal",
  freeTips5: "Eliminación del fondo de 1 foto al día",
  freeTips52: "Eliminación del fondo de 1 foto al día",
  freeTips6: "Acceso a todas las herramientas gratuitas",
  vipTips1: "Tamaño de archivo ilimitado",
  vipTips2: "Archivos ilimitados por día",
  vipTips3: "Mejorar la velocidad de descarga",
  vipTips4: "Mejorar la velocidad de procesamiento",
  vipTips5: "Ilimitado",
  vipTips6: "Eliminación de fondos de imágenes ilimitada por día",
  vipTips7: "Acceso a todas las herramientas y funciones premium",
  vipTips8: "Renovar automáticamente y cancelar en cualquier momento.",
  vipTips9: "Sin límites en el tamaño y la cantidad de vídeos",
  vipTips10: "Sin límites en eliminar fondos de imágenes",
  vipTips11: "Mejorar el procesamiento de video y la velocidad de descarga",
  vipTips12: "Acceso a todas las herramientas gratuitas & funciones premium",
  acceptTitle: "Aceptamos",
  modalTitle: "Actualiza a Pro para acceder a todas las funciones premium",
  total: "Total",
  enterCode: "Introduzca el código",
  SignUpToPurchaseBtn: "Regístrese para comprar",
  purchaseBtn: "Ir a la compra",
  saveTips: "Ahorre hasta un {{num}}%.",
  discount: "Descuento",
  purchaseTips: "Renovar automáticamente y cancelar en cualquier momento.",
  tips: "Consejos:",
  promoCodeInvalidTips: "Su código de promoción no es válido",
};

export default purchase;
